import serverApi from "../utils/serverApi"

const quizService = {
  getQuiz: () => serverApi({ uri: 'account/quiz', method: 'GET' }),
  checkQuizStatus: () => serverApi({ uri: 'account/quiz/status', method: 'GET' }),
  answerQuiz: (body) => serverApi({ uri: 'account/quiz', method: 'POST', data: body, isLoading: true, isNotify: false, isManualErrorHandling: true }),
};

export default quizService;